// extracted by mini-css-extract-plugin
export default {"main":"calendar_main__e8ffc","darkBG":"calendar_darkBG__KcNO6","box":"calendar_box__xx3X2"};